import React from 'react';
import PropTypes from 'prop-types';
import useStyle from './style';
import cx from '@/utils/cx';

const LoadingBalls = ({ _color, width, className }) => {
  const classes = useStyle({ _color, width });

  return (
    <div className={cx(classes.loadingBalls, className)}>
      <div className="ball" />
      <div className="ball" />
      <div className="ball" />
    </div>
  );
};

LoadingBalls.propTypes = {
  _color: PropTypes.string,
  width: PropTypes.number,
  className: PropTypes.string,
};

LoadingBalls.defaultProps = {
  _color: 'primary',
  width: 90,
  className: '',
};

export default LoadingBalls;
